export default __webpack_public_path__ + "static/media/chevron-right 2.96336df6.svg";